import React from "react";

import useAuthState from "../../hooks/useAuthState";
import { Image } from "../../atoms/Image";

import styles from "./SidebarProfileFooter.module.scss";
import { Popover, Button, Menu, MenuItem } from "@blueprintjs/core";

import { useQuery } from "@apollo/react-hooks";
import { GetProfileInfo } from "../../pages/Onboarding/ProfileInfo/queries";
import { Icon } from "../../atoms/Icon";
import ChatButton from "../../pages/ChatPanel/ChatButton";

function SidebarProfileFooter({ collapsed }) {
  const { logout } = useAuthState();
  const { data } = useQuery(GetProfileInfo);
  const user = data && data.accounts && data.accounts[0];

  return (
    <div className={styles.footerWrapper}>
      <div className={styles.footer}>
        <div className={styles.brandProfilePicture}>
          <Popover>
            <Image
              src={
                user
                  ? user.picture
                  : "https://s3-us-west-1.amazonaws.com/avatars-zipline-co/default-avatar.png"
              }
              alt="Brand Profile Picture"
              circle
              noShadow
            />
            {collapsed && (
              <Menu style={{ minWidth: "120px" }}>
                <MenuItem
                  icon="log-out"
                  onClick={logout}
                  text="Log Out"
                  style={{ padding: "5px 17px" }}
                />
              </Menu>
            )}
          </Popover>
        </div>
        <ChatButton />
        <Button
          className={styles.helpBtn}
          icon={"help"}
          large
          minimal
          onClick={() => {
            const element = document.getElementById("intercom-container");
            if (element.className.includes("show")) {
              window.Intercom("hide");
              element.classList.remove("show");
            } else {
              window.Intercom("show");
              element.classList.add("show");
            }
          }}
        />
        {!collapsed && (
          <Button
            className={styles.btnLogout}
            rightIcon={<Icon name="log-out" color="#983030" size={20} />}
            onClick={logout}
            large
            minimal
          >
            Logout
          </Button>
        )}
      </div>
    </div>
  );
}

export default SidebarProfileFooter;
